$( document ).ready(function() {
    $('.black-box button').click(function() {
      $('html, body').animate({scrollTop : 0},500);
		  return false;
    })
});
